export { useI18nDateTimeFormats } from "./useI18nDateTimeFormats.js";
export { useI18nNumberFormats } from "./useI18nNumberFormats.js";
const CA = "ca";
const DE = "de";
const DE_AT = "de-at";
const DE_CH = "de-ch";
const EN = "en";
const EN_GB = "en-gb";
const EN_IE = "en-ie";
const EN_US = "en-us";
const ES = "es";
const FR = "fr";
const FR_BE = "fr-be";
const FR_CH = "fr-ch";
const IT = "it";
const IT_CH = "it-ch";
const NL = "nl";
const NL_BE = "nl-be";
const PT = "pt-pt";
export const LOCALE_CODES = {
  CA,
  DE,
  DE_AT,
  DE_CH,
  EN,
  EN_GB,
  EN_IE,
  EN_US,
  ES,
  FR,
  FR_BE,
  FR_CH,
  IT,
  IT_CH,
  NL,
  NL_BE,
  PT
};
export const LOCALE_CODES_ISO = {
  [CA]: "ca",
  [DE]: "de",
  [DE_AT]: "de-AT",
  [DE_CH]: "de-CH",
  [EN]: "en-GB",
  [EN_GB]: "en-GB",
  [EN_IE]: "en-IE",
  [EN_US]: "en-US",
  [ES]: "es",
  [FR]: "fr",
  [FR_BE]: "fr-BE",
  [FR_CH]: "fr-CH",
  [IT]: "it",
  [IT_CH]: "it-CH",
  [NL]: "nl",
  [NL_BE]: "nl-BE",
  [PT]: "pt"
};
export const FALLBACK_LOCALE_POLICY = {
  [DE_AT]: [DE],
  [DE_CH]: [DE],
  [EN_IE]: [EN_GB],
  [EN_US]: [EN_GB],
  [FR_BE]: [FR],
  [FR_CH]: [FR],
  [IT_CH]: [IT],
  [NL_BE]: [NL],
  default: [FR]
};
